<template src="../templates/culled.pug" lang="pug"></template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { format, parse } from 'date-fns'
import differenceInYears from 'date-fns/difference_in_years'
import differenceInMonths from 'date-fns/difference_in_months'
import 'vue-loaders/dist/vue-loaders.css'
import _filter from 'lodash/filter'
import _countBy from "lodash/countBy"
import _some from 'lodash/some'
import BuildingForm from "@/views/form/BuildingForm.vue"
import AnimalForm from "@/views/form/AnimalForm.vue"
import AnimalCard from "@/views/card/AnimalCard.vue"

export default {
    name: 'Culled',
    components: {
        AnimalCard
    },
    data() {
        return {
            showBuildingForm: false,
            searchInput: '',
            selectedAnimal: null,
            format
        }
    },
    computed: {
        ...mapGetters([
            'culled',
            'culledLoading',
            'selectedFarm',
            'filteredCulledAnimals',
            'filterCulled',
            'countCulledAnimal',
            'countCulledByType',
            'farmCulledType',
            'filterTypes',
            'countCulledByParam',
            'isColumnOrdered'
        ]),
        filteredAnimals() {
            if (this.searchInput.length > 0) {
                let self = this
                return _filter(this.culled, function(a) {
                    let str = a.buckleNumber.toString()
                    return str.includes(self.searchInput)
                })
            } else {
                return this.filteredCulledAnimals
            }
        }
    },
    created() {
        this.fetchCulled()
    },
    methods: {
        ...mapActions(['fetchCulled']),
        ...mapMutations([
            'updateFilterCulled',
            'resetFilterCulled',
            'updateFilterType',
            'resetFilterType',
            'updateTableOrder'
        ]),
        getAge(birthday) {
            let years = differenceInYears(Date.now(), new Date(birthday * 1000))
            let months = differenceInMonths(parse(Date.now()), new Date(birthday * 1000))
            let age = ''
            if (years > 0) {
                age += years + ' years '
            }
            if (months - years * 12 > 0) {
                age += months - years * 12 + ' months'
            }
            if (months === 0) {
                age += 'less than 1 months'
            }
            return age
        },
        getLastMilkResult(milkResults) {
            if (milkResults.length > 0) return milkResults[0].total
            else return ''
        }
    }
}
</script>

<style lang="sass" scoped>
    @import '../sass/mixin/color'
    @import '../sass/mixin/flex'

    #culled
        .filter-container
            .filters-list
                .filter-building
                    background-color: $dd-lime-green
                .filter-type
                    background-color: $dd-soft-pink
        .content
            .button-row
                .round-button-effect
                    padding: 1em
                    .round-button-icon
                        fill: $dd-very-dark-gray
                        box-shadow: 0 0 0 4px $dd-very-dark-gray
                    &:hover
                        svg
                            background: $dd-very-dark-gray none repeat scroll 0 0
                            fill: white
            .cell-buckle-number
                cursor: pointer
                &:hover
                    font-size: 18px
                    font-weight: bold
                    color: $dd-light-orange

        .table-header
            background-color: $dd-very-dark-gray
</style>
